export const adminOrdersStatuses = [
  'pending',
  'canceled',
  'paid',
  'paid_offline',
  'waiting_for_offline_payment',
  'all',
] as const;

export type AdminOrdersStatusesType = (typeof adminOrdersStatuses)[number];

export const adminOrdersFilterStatusesMap: Record<string, string[]> = {
  refunded: ['refunded', 'partially_refunded'],
};

export const getFilterApiStatuses = (status: string): string[] => adminOrdersFilterStatusesMap[status] || [status];
